$(document).ready(function () {
  try {
    $('body').on('click', '.qty-wrapper span', function () {
      var $this = $(this);
      var qtyInput = $this.parent().find('input');
      var qtyInputVal = qtyInput.val();
      qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

      if ($this.hasClass('qty-plus')) {
        qtyInputVal++;
        qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
      } else {
        qtyInputVal--;
        qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
      }
      qtyInput.val(qtyInputVal).trigger('change');
    });
  } catch (e) {
    Rollbar.error('qty js', e);
  }
});
